import { NavLink } from "react-router-dom";
import GavelIcon from "@mui/icons-material/Gavel";
import "./styles.scss";

type LogoProps = {
	onClick?: () => void;
};

export default function Logo({ onClick }: LogoProps) {
	return (
		<NavLink to={"/"} className="logo-container" onClick={onClick}>
			<GavelIcon className="logo-icon" />
			<label className="logo-label">شكاوي</label>
		</NavLink>
	);
}
